export const DOCUMENT_OPTIONS = [
  "id",
  "name",
  "signedBy",
  "description",
  "status",
  "createdBy",
  "createdAt",
  "Files",
  "importance",
];
